import { render, staticRenderFns } from "./AddEvent.vue?vue&type=template&id=d51c214a&"
import script from "./AddEvent.vue?vue&type=script&lang=js&"
export * from "./AddEvent.vue?vue&type=script&lang=js&"
import style0 from "./AddEvent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports